import { addTelemetryDebug } from '@datadog/browser-core';
export function createElementsScrollPositions() {
  var scrollPositionsByElement = new WeakMap();
  var documentScrollingElement;
  return {
    set: function set(element, scrollPositions) {
      if (element === document && !documentScrollingElement) {
        documentScrollingElement = tryToFindScrollingElement(scrollPositions);

        if (!documentScrollingElement) {
          return;
        }
      }

      try {
        scrollPositionsByElement.set(element === document ? documentScrollingElement : element, scrollPositions);
      } catch (e) {
        addTelemetryDebug("invalid element: ".concat(String(element)));
      }
    },
    get: function get(element) {
      return scrollPositionsByElement.get(element);
    },
    has: function has(element) {
      return scrollPositionsByElement.has(element);
    }
  };
}

function tryToFindScrollingElement(scrollPositions) {
  if (document.scrollingElement) {
    return document.scrollingElement;
  }

  addTelemetryDebug('null document scrolling element');

  if (scrollPositions.scrollLeft === 0 && scrollPositions.scrollTop === 0) {
    addTelemetryDebug('Unable to find scrolling element for scroll (0,0)');
    return null;
  }

  if (Math.round(document.documentElement.scrollLeft) === scrollPositions.scrollLeft && Math.round(document.documentElement.scrollTop) === scrollPositions.scrollTop) {
    return document.documentElement;
  }

  addTelemetryDebug('Unable to find scrolling element');
  return null;
}